import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SatisfactionState } from './state';
import { SatisfactionDTO } from '@/models/Satisfaction';

export const getters: GetterTree<SatisfactionState, RootState> = {
    getSocietes(state): any[] {
        return state.societes;
    },
    getSocieteIdSelectionnee(state): any {
        return state.societeIdSelectionnee;
    },
    getSatisfaction(state): SatisfactionDTO | undefined {
        return state.satisfaction;
    },
};
